<template>
    <div>
        <v-file-input
                v-model="data.sampleFiles"
                label=" بارگذاری فایل نمونه "
                outlined
                placeholder="لطفا فایل موردنظر خود را بارگذاری کنید."
                prepend-inner-icon="mdi-camera"
                clearable
                small-chips
                clear-icon="mdi-close-circle-outline"
                prepend-icon=""
                multiple
                dense
                class="mt-1 mx-3 pt-1"
        ></v-file-input>
        <v-file-input
                v-model="data.files"
                label=" بارگذاری فایل اصلی "
                outlined
                placeholder="لطفا فایل موردنظر خود را بارگذاری کنید."
                prepend-inner-icon="mdi-camera"
                clearable
                small-chips
                clear-icon="mdi-close-circle-outline"
                prepend-icon=""
                multiple
                dense
                class="mt-1 mx-3 pt-1"
        ></v-file-input>

        <v-btn @click="uploadFile" :loading="loading" class="submit-btn">
            <span class="fa fa-save ml-1" style="font-size: 1.5rem"></span>
            ثبت درخواست
        </v-btn>
    </div>
</template>

<script>
import {createFormData} from "../../../Utilities/FormRequestHelper";

export default {
    name: "senSample",
    props: {
        formId: {
            default: 0
        },
        type: {
            default: ''
        },
    },
    data() {
        return {
            loading:false,
            data:{
                model:this.type,
                form_id:this.formId,
                sampleFiles :[],
                files :[],
            }
        }
    },
    methods: {
        uploadFile() {
            this.loading=true
            this.requestApiPost('admin/form/uploadFile',createFormData(this.data)).then((response) => {
                this.loading = false;
            }).finally(()=>{
                this.loading = false;
                this.$toast.success('فایل شما با موفقیت آپلود شد.')
            })
        }
    }
}
</script>

<style scoped>

</style>